import { render } from "./KeyboardView.vue?vue&type=template&id=495ed6e6&scoped=true&ts=true"
import script from "./KeyboardView.vue?vue&type=script&lang=ts"
export * from "./KeyboardView.vue?vue&type=script&lang=ts"

import "./KeyboardView.vue?vue&type=style&index=0&id=495ed6e6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495ed6e6"]])

export default __exports__